import { graphql } from "react-relay";

// components
import "@components/flow-state-poller/FlowStatePoller.gql";
import "@components/web-app-chrome-card/WebAppChromeCard.gql";

export const webAppFragments = {
  viewer: graphql`
    fragment WebApp_viewer on Viewer {
      ...WebAppChromeCard_viewer
      user {
        flowStates(first: 1000000) {
          edges {
            node {
              ...FlowStatePoller_flowState
              id
              flowKey
              previousState
              current {
                id
                state
                percentComplete
                errorMessage
              }
              pending {
                id
                state
                percentComplete
                errorMessage
              }
            }
          }
        }
        orgs(first: 1000000) {
          edges {
            node {
              id
              domains
              primaryOrgCalendar
              shadowCalendarSettingsErrorable {
                ... on ShadowCalendarSettings {
                  shadowCalendarId
                }
              }
              orgMeetingHours {
                workingHours {
                  timeZone
                }
              }
              flowStates(first: 1000000) {
                edges {
                  node {
                    ...FlowStatePoller_flowState
                    id
                    flowKey
                    previousState
                    current {
                      id
                      state
                      percentComplete
                      errorMessage
                    }
                    pending {
                      id
                      state
                      percentComplete
                      errorMessage
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `,
};

export const webAppQuery = graphql`
  query WebAppQuery {
    viewer {
      ...WebApp_viewer
    }
  }
`;
